import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import ToggleButton from "react-bootstrap/ToggleButton";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import InputGroup from "react-bootstrap/InputGroup";

// Imports (door Tom)
import FormControl from "react-bootstrap/FormControl";
import Form from "react-bootstrap/Form";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import CardGroup from "react-bootstrap/CardDeck";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";

import { FaCheck } from "react-icons/fa";

import PageControl from "../components/PageControl";

import { CustomerNameTooltip, CustomerEmailTooltip, CustomerBTWTooltip, CustomerStreetTooltip, CustomerNumberTooltip, CustomerZipTooltip, CustomerCityTooltip } from "../components/tooltips/CustomerTooltips"
import DesignStepToolTip from "./tooltips/DesignStepToolTip";


function SidePanel(props) {

  let panelContent;
  let panelTitle;
  let pageControl = <PageControl page={props.designstep} prevPage={props.prevPage} nextPage={props.nextPage} handleOrderPopup={props.handleOrderPopup} />;

  let wallSideSelector;
  if (props.closetProps.type === "half") {
    wallSideSelector = (
      <div>
        <Row>
          <p>Staat de kast links of rechts tegen de muur?</p>
        </Row>
        <ToggleButtonGroup type='radio' name='halfType' onChange={props.handleHalfType} value={props.closetProps.halfType}>
          <ToggleButton value='left'>Links</ToggleButton>
          <ToggleButton value='right'>Rechts</ToggleButton>
        </ToggleButtonGroup>
      </div>
    );
  } else {
    wallSideSelector = null;
  }

  function _hasNoSingleModules() {
    const modules = props.slots

    for (let i = 0; i < modules.length; i++) {
      if (modules[i]?.moduleData != null && modules[i]?.moduleData?.module_size === 1)
        return false;
    }

    return true;
  }

  function _hasNoDoubleModules() {
    const modules = props.slots

    for (let i = 0; i < modules.length; i++) {
      if (modules[i]?.moduleData != null && modules[i]?.moduleData?.module_size === 2)
        return false;
    }

    return true;
  }


  // Set Active Module / Handgreep
  function _setActive(e, type, object) {
    const target = e.target;

    const cardDecks = target.closest(".row").querySelectorAll(".card-deck");
    cardDecks.forEach((cardDeck) => {
      const cards = cardDeck.querySelectorAll(".card");
      cards.forEach((card) => {
        card.childNodes[0].classList.add("card-hide");
      });
    });

    if (target.classList.contains("card")) {
      target.childNodes[0].classList.remove("card-hide");
    } else {
      const card = target.closest(".card");
      card.childNodes[0].classList.remove("card-hide");
    }

    switch (type) {
      case 'Module':
        props.setActiveModule(object)
        break;
      case 'Greep':
        props.setActiveGrip(object)
        break;
      case 'Scharnier':
        // props.setActiveModule(object)
        break;
      default:
        break;
    }
  }

  function _validateInputs(type, e) {
    const errorMessage = e.target.closest(".col-lg-8").querySelector(".size-input-validation-error");
    errorMessage.innerHTML = "";
    e.target.style.border = "";

    const value = +e.target.value;
    const min = +e.target.getAttribute("min");
    const max = +e.target.getAttribute("max");

    const oldValue = e.target.getAttribute("data-old-input");

    if (oldValue) {
      if (value > max) {
        e.target.value = +oldValue;

        // Error Styling + Display
        e.target.style.border = "1px solid #ff0000";
        errorMessage.innerHTML = `Geef een waarde tussen ${min} en ${max}`;
      } else if (value > max) {
        if (+oldValue > min) {
          e.target.value = +oldValue;

          // Error Styling + Display
          e.target.style.border = "1px solid #ff0000";
          errorMessage.innerHTML = `Geef een waarde tussen ${min} en ${max}`;
        }
      }

      // Clear errorMessage if the 'oldValue' (which is now the actual value) is between the min & max
      if (value >= min && value <= max) {
        errorMessage.innerHTML = "";
        e.target.style.border = "";
      }
    }

    e.target.setAttribute("data-old-input", value);

    props.setBoxDimensions(type, value);
  }

  switch (props.designstep) {
    case 1:
      panelTitle = "1. Kamer";
      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <Col lg={4}>
              <p>Kast Breedte:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3 no-bottom-margin'>
                <FormControl type='number' onChange={(e) => _validateInputs("B", e)} placeholder='350' min={props.validationSizes.minWidth} max={props.validationSizes.maxWidth} aria-label='Kamer Breedte' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>{props.room.room_type.includes("Plafond") ? "Kamer Hoogte:" : "Kast Hoogte"}</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3 no-bottom-margin'>
                <FormControl type='number' onChange={(e) => _validateInputs("H", e)} placeholder='180' min={props.validationSizes.minHeight} max={props.validationSizes.maxHeight} aria-label='Kamer Hoogte' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Kast Diepte:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3 no-bottom-margin'>
                <FormControl type='number' onChange={(e) => _validateInputs("D", e)} placeholder='65' min={props.validationSizes.minDepth} max={props.validationSizes.maxDepth} aria-label='Kamer Diepte' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Afwerking Links:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("AL", e)} placeholder='5' min={props.validationSizes.minLeft} max={props.validationSizes.maxLeft} aria-label='Afwerking Links' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Afwerking Rechts:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("AR", e)} placeholder='5' min={props.validationSizes.minRight} max={props.validationSizes.maxRight} aria-label='Afwerking Rechts' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Plint Boven:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("PB", e)} placeholder='5' min={props.validationSizes.minBottom} max={props.validationSizes.maxBottom} aria-label='Plint Boven' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Plint Onder:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("PO", e)} placeholder='8' min={props.validationSizes.minTop} max={props.validationSizes.maxTop} aria-label='Plint Onder' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row>
            <Col lg={4}>
              <p>Muurkleur:</p>
            </Col>
            <Col lg={8}>
              <Form.Control type='color' onChange={e => props.setWallColor(e.target.value)} />
            </Col>
          </Row>
          {/* <Row noGutters>
            <h5>Vloertextuur</h5>
          </Row>
          <Row>
            <div className={styles["colorpicker-container"]}>
              {props.materials.map((material) => {

                //console.log(props.closetProps)
                // if (props.closetProps.innerMaterial !== null && material.material_id === props.closetProps.innerMaterial.material_id)
                //   return (
                //     <span
                //       key={material.material_id}
                //       className={styles.dot + " inside " + styles.active}
                //       style={{ backgroundImage: "url(" + material.material_texture_path + ")" }}
                //       onClick={(e) => {

                //         const dots = document.getElementsByClassName(styles.dot);

                //         for (var i = 0; i < dots.length; i++) {
                //           const dot = dots[i];
                //           if (dot.classList.contains("inside"))
                //             dot.classList.remove(styles.active)
                //         }

                //         e.target.classList.add(styles.active)

                //         props.setMaterial(material, "in");
                //       }}>
                //     </span>
                //   );
                // else
                //   return (
                //     <span
                //       key={material.material_id}
                //       className={styles.dot + " inside"}
                //       style={{ backgroundImage: "url(" + material.material_texture_path + ")" }}
                //       onClick={(e) => {

                //         const dots = document.getElementsByClassName(styles.dot);

                //         for (var i = 0; i < dots.length; i++) {
                //           const dot = dots[i];
                //           if (dot.classList.contains("inside"))
                //             dot.classList.remove(styles.active)
                //         }

                //         e.target.classList.add(styles.active)

                //         props.setMaterial(material, "in");
                //       }}>
                //     </span>
                //   );
              })}
            </div>
          </Row> */}
        </Container>
      );
      break;
    // case 1:
    //   // console.log(props.closetProps.lat);
    //   panelContent = (
    //     <Container fluid>
    //       <Row noGutters>
    //         <p>Hoe wens je de paslatten te ontvangen?</p>
    //       </Row>

    //       <Row noGutters>
    //         <Col>
    //           <FormControl type='radio' value='over' id='radio-over' name='paslat' onChange={(e) => props.handleLat(e.target.value)} checked={props.closetProps.lat == "over" ? true : false} />
    //           <FormLabel htmlFor='radio-over'>Overmaat</FormLabel>
    //         </Col>
    //       </Row>

    //       <Row noGutters>
    //         <Col>
    //           <FormControl type='radio' value='fitted' id='radio-fitted' name='paslat' onChange={(e) => props.handleLat(e.target.value)} checked={props.closetProps.lat == "fitted" ? true : false} />
    //           <FormLabel htmlFor='radio-fitted'>Op maat</FormLabel>
    //         </Col>
    //       </Row>

    //       <Row noGutters>
    //         <Col>
    //           <FormControl type='radio' value='after' id='radio-after' name='paslat' onChange={(e) => props.handleLat(e.target.value)} checked={props.closetProps.lat == "after" ? true : false} />
    //           <FormLabel htmlFor='radio-after'>Op maat nageleverd</FormLabel>
    //         </Col>
    //       </Row>
    //     </Container>
    //   );
    //   panelTitle = "2. Paslatten";
    //   break;
    case 2:
      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <p>Lijst van verschillende mogelijke modules.</p>
          </Row>
          {/* NOTE: Pas de code hieronder aan (is placeholder code voor style), LET WEL OP! Als ik een bepaalde className gebruik voor style, dan gebruik die ook in het 'echte' design */}
          <Row noGutters className='row-card-container'>
            <Col>
              <Tabs defaultActiveKey='single' id='module-tab'>
                <Tab eventKey='single' title='Enkel'>
                  <CardGroup>
                    {props.modules.single.map(module => {
                      // console.log(module)
                      return (
                        <Card key={module.module_id} onClick={(e) => _setActive(e, "Module", module)}>
                          <div className='card-active card-hide'>
                            <FaCheck />
                          </div>
                          <Card.Img src={module.module_model_thumbnail_path} />
                        </Card>)
                    })}
                  </CardGroup>
                </Tab>

                <Tab eventKey='double' title='Dubbel'>
                  <CardGroup>
                    {props.modules.double.map(module => {
                      // console.log(module)
                      return (
                        <Card key={module.module_id} onClick={(e) => _setActive(e, "Module", module)}>
                          <div className='card-active card-hide'>
                            <FaCheck />
                          </div>
                          <Card.Img src={module.module_model_thumbnail_path} />
                        </Card>)
                    })}
                  </CardGroup>
                </Tab>
              </Tabs>
            </Col>
          </Row>
          {/* <Col>
              <Button variant="danger">Rode</Button>
            </Col>
            <Col>
              <Button variant="success">Groene</Button>
            </Col>
            <Col>
              <Button variant="primary">Blauwe</Button>
            </Col> */}
        </Container>
      );
      panelTitle = "2. Modules";
      break;
    case 3:
      panelContent = (
        <Container fluid>
          <Row noGutters>
            <p>In welke kleur wil je je kast?</p>
          </Row>

          <Row noGutters>
            <div className="colorpicker-container">
              <h5>Binnenkant</h5>
              <h6 id="inner-color-hover-display">Geselecteerde kleur: geen</h6>
              {props.materials.map((material) => {
                //console.log(props.closetProps)
                if (props.closetProps.innerMaterial !== null && material.material_base_name === props.closetProps.innerMaterial.material_base_name)
                  return (
                    <span
                      key={material.material_base_name + "-inner"}
                      className="dot inside active"
                      id={material.material_base_name}
                      style={{ backgroundImage: "url(\"" + material.material_texture_path + "\")" }}
                      onClick={(e) => {

                        const dots = document.getElementsByClassName('dot');

                        const materialNameDisplay = document.getElementById("inner-color-hover-display")
                        materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                        for (var i = 0; i < dots.length; i++) {
                          const dot = dots[i];
                          if (dot.classList.contains("inside"))
                            dot.classList.remove('active')
                        }

                        e.target.classList.add('active')

                        props.setMaterial(material, "in");
                      }} />
                  );
                else
                  return (
                    <span
                      key={material.material_base_name + "-inner"}
                      className="dot inside"
                      id={material.material_base_name}
                      style={{ backgroundImage: "url(\"" + material.material_texture_path + "\")" }}
                      onClick={(e) => {

                        const dots = document.getElementsByClassName('dot');

                        const materialNameDisplay = document.getElementById("inner-color-hover-display")
                        materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                        for (var i = 0; i < dots.length; i++) {
                          const dot = dots[i];
                          if (dot.classList.contains("inside"))
                            dot.classList.remove('active')
                        }

                        e.target.classList.add('active')

                        props.setMaterial(material, "in");
                      }}>
                    </span>
                  );
              })}
            </div>
          </Row>

          <Row noGutters>
            <div className="colorpicker-container">
              <h5>Buitenkant</h5>
              <h6 id="outer-color-hover-display">Geselecteerde kleur: geen</h6>
              {props.materials.map((material) => {
                if (props.closetProps.outerMaterial !== null && material.material_base_name === props.closetProps.outerMaterial.material_base_name)
                  return (
                    <span
                      key={material.material_base_name + "-outer"}
                      id={material.material_base_name}
                      className="dot outside active"
                      style={{ backgroundImage: "url(\"" + material.material_texture_path + "\")" }}
                      onClick={(e) => {

                        const dots = document.getElementsByClassName('dot');

                        const materialNameDisplay = document.getElementById("outer-color-hover-display")
                        materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                        for (var i = 0; i < dots.length; i++) {
                          const dot = dots[i];
                          if (dot.classList.contains("outside"))
                            dot.classList.remove('active')
                        }

                        e.target.classList.add('active')

                        props.setMaterial(material, "out");
                      }}>
                    </span>
                  );
                else
                  return (
                    <span
                      key={material.material_base_name + "-outer"}
                      id={material.material_base_name}
                      className="dot outside"
                      style={{ backgroundImage: "url(\"" + material.material_texture_path + "\")" }}
                      onClick={(e) => {

                        const dots = document.getElementsByClassName('dot');

                        const materialNameDisplay = document.getElementById("outer-color-hover-display")
                        materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                        for (var i = 0; i < dots.length; i++) {
                          const dot = dots[i];
                          if (dot.classList.contains("outside"))
                            dot.classList.remove('active')
                        }

                        e.target.classList.add('active')

                        props.setMaterial(material, "out");
                      }}>
                    </span>
                  );
              })}
            </div>
          </Row>
        </Container>
      );
      panelTitle = "3. Materialen";
      break;
    case 4:
      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <p>Je kast is bijna klaar… Het enige wat je nog hoeft te doen, is de extra's kiezen.</p>
          </Row>
          <Row noGutters className='row-card-container'>
            <Col>
              <Tabs defaultActiveKey={props.featureTypes[0].feature_type_id}>
                {props.featureTypes.map(featureType => {
                  // console.log(featureType)
                  return (
                    <Tab key={featureType.feature_type_id} eventKey={featureType.feature_type_id} title={featureType.feature_type_name}>
                      <CardGroup>
                        {props.features[featureType.feature_type_name].map(feature => {
                          return <Card key={feature.feature_id} onClick={(e) => _setActive(e, featureType.feature_type_name, feature)}>
                            <div className='card-active card-hide'>
                              <FaCheck />
                            </div>
                            <Card.Img src={feature.feature_thumbnail_path} />
                          </Card>
                        })}
                      </CardGroup>
                    </Tab>
                  )
                })}
                {/* <Tab eventKey='pas' title='Paslatten'>
                  <h3>Hoe wens je de paslatten te ontvangen?</h3>
                  <CardGroup>
                    <Card onClick={(e) => _setActive(e)}>
                      <div className='card-active card-hide'>
                        <FaCheck />
                      </div>
                      <Card.Img src='https://via.placeholder.com/150' />
                    </Card>
                    <Card onClick={(e) => _setActive(e)}>
                      <div className='card-active card-hide'>
                        <FaCheck />
                      </div>
                      <Card.Img src='https://via.placeholder.com/150' />
                    </Card>
                  </CardGroup>
                </Tab> */}
              </Tabs>
            </Col>
          </Row>
        </Container >
      );
      panelTitle = "4. Extra's";
      break;
    case 5:


      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <p>De kast is ontworpen, bestellen maar!</p>
          </Row>
          <div className="summary">
            <h6>Kamer</h6>
            <p>Breedte: {props.boxDimensions.B}cm</p>
            <p>Hoogte: {props.boxDimensions.H}cm</p>
            <p>Diepte (Kast): {props.boxDimensions.D}cm</p>
            <p>Afwerking (L): {props.boxDimensions.AL}cm</p>
            <p>Afwerking (R): {props.boxDimensions.AR}cm</p>
            <p>Plint (B): {props.boxDimensions.PB}cm</p>
            <p>Plint (O): {props.boxDimensions.PO}cm</p>

            <br />

            <h6>Modules</h6>
            <p>Enkel: {_hasNoSingleModules() ? 'Geen' : ''}</p>
            <CardGroup>
              {props.slots.map((module, index) => {
                return module?.moduleData == null || module?.moduleData?.module_size != 1 ? null : <Card className="card-flex-10p" key={index}>
                  <Card.Img src={module?.moduleData?.module_model_thumbnail_path} title={module?.moduleData?.module_name} alt={module?.moduleData?.module_name} />
                </Card>
              })}
            </CardGroup>

            <p>Dubbel: {_hasNoDoubleModules() ? 'Geen' : ''}</p>
            <CardGroup>
              {props.slots.map((module, index) => {
                return module?.moduleData == null || module?.moduleData?.module_size != 2 ? null : <Card key={index}>
                  <Card.Img src={module?.moduleData?.module_model_thumbnail_path} title={module?.moduleData?.module_name} alt={module?.moduleData?.module_name} />
                </Card>
              })}
            </CardGroup>

            <br />

            <h6>Materialen</h6>
            <p>Binnenkant: {props.closetProps.innerMaterial?.material_base_name ?? "Geen"}</p>
            <p>Buitenkant: {props.closetProps.outerMaterial?.material_base_name ?? "Geen"}</p>

            <br />

            <h6>Handgreep</h6>
            <CardGroup>
              <Card className="card-flex-10p">
                <Card.Img src={props.activeGrip?.feature_thumbnail_path} title={props.activeGrip?.feature_name + " (" + props.activeGrip?.feature_type_name + ")"} alt={props.activeGrip?.feature_name + " (" + props.activeGrip?.feature_type_name + ")"} />
              </Card>
            </CardGroup>
            <p></p>
            {props.orderErrors["order_error"] ? <Alert variant='danger'>{props.orderErrors["order_error"]}</Alert> : null}
          </div>

          <Modal show={props.showOrderPopup} onHide={() => props.handleOrderPopup(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Bestelgegevens</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form method='POST' encType='multipart/form-data' onSubmit={props.submitOrder}>
                <Form.Group>
                  <Form.Label>
                    Naam <CustomerNameTooltip />
                  </Form.Label>
                  <Form.Control type='text' placeholder='Naam' name='customer_name' />
                  <span className={props.formErrors["customer_name"] ? "form-error" : "form-error-hidden"}>{props.formErrors["customer_name"]}</span>
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    E-mailadres <CustomerEmailTooltip />
                  </Form.Label>
                  <Form.Control type='email' placeholder='E-mailadres' name='customer_email' />
                  <span className={props.formErrors["customer_email"] ? "form-error" : "form-error-hidden"}>{props.formErrors["customer_email"]}</span>
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    BTW-nummer (optioneel) <CustomerBTWTooltip />
                  </Form.Label>
                  <Form.Control type='text' placeholder='BTW-nummer' name='customer_btw' />
                  <span className={props.formErrors["customer_btw"] ? "form-error" : "form-error-hidden"}>{props.formErrors["customer_btw"]}</span>
                </Form.Group>

                {/* Start Bezorg Adres */}
                <h5>Bezorgadres</h5>
                <Form.Group>
                  <Form.Label>
                    Straatnaam <CustomerStreetTooltip />
                  </Form.Label>
                  <Form.Control type='text' placeholder='Straatnaam' name='customer_delivery_street' />
                  <span className={props.formErrors['customer_delivery_street'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_street']}</span>
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    Huisnummer & Bus <CustomerNumberTooltip />
                  </Form.Label>
                  <Form.Control type='text' placeholder='Huisnummer & Bus' name='customer_delivery_number' />
                  <span className={props.formErrors['customer_delivery_number'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_number']}</span>
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>
                        Postcode <CustomerZipTooltip />
                      </Form.Label>
                      <Form.Control type='text' placeholder='Postcode' name='customer_delivery_zip' />
                      <span className={props.formErrors['customer_delivery_zip'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_zip']}</span>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>
                        Gemeente <CustomerCityTooltip />
                      </Form.Label>
                      <Form.Control type='text' placeholder='Gemeente' name='customer_delivery_city' />
                      <span className={props.formErrors['customer_delivery_city'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_city']}</span>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Start Factuur Adres */}
                <h5>Factuuradres</h5>
                <Form.Group>
                  <Form.Check type="checkbox" id="invoice_address_checkbox" name="customer_invoice_equals_delivery" label="Hetzelfde als bezorgadres" onChange={props.toggleHideInvoiceAddress} checked={props.hideInvoiceAddress} />
                </Form.Group>

                <div className={props.hideInvoiceAddress ? "card-hide" : ""}>
                  <Form.Group>
                    <Form.Label>
                      Straatnaam <CustomerStreetTooltip />
                    </Form.Label>
                    <Form.Control type='text' placeholder='Straatnaam' name='customer_invoice_street' />
                    <span className={props.formErrors['customer_invoice_street'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_street']}</span>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>
                      Huisnummer & Bus <CustomerNumberTooltip />
                    </Form.Label>
                    <Form.Control type='text' placeholder='Huisnummer & Bus' name='customer_invoice_number' />
                    <span className={props.formErrors['customer_invoice_number'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_number']}</span>
                  </Form.Group>
                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          Postcode <CustomerZipTooltip />
                        </Form.Label>
                        <Form.Control type='text' placeholder='Postcode' name='customer_invoice_zip' />
                        <span className={props.formErrors['customer_invoice_zip'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_zip']}</span>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          Gemeente <CustomerCityTooltip />
                        </Form.Label>
                        <Form.Control type='text' placeholder='Gemeente' name='customer_invoice_city' />
                        <span className={props.formErrors['customer_invoice_city'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_city']}</span>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                <Button variant='primary' type='submit'>
                  Bestellen
                </Button>
                <p></p>
                {props.formErrors["order_error"] ? <Alert variant='danger'>{props.formErrors["order_error"]}</Alert> : null}
              </Form>
            </Modal.Body>
          </Modal>
        </Container>
      );
      panelTitle = "5. Bestelling plaatsen";
      break;
    default:
  }

  return (
    <div className='side-panel'>
      <Row style={{ justifyContent: "flex-end", paddingRight: "15px" }}>
        <DesignStepToolTip helps={props.helps} designstep={props.designstep} />
      </Row>
      <Row className='side-panel-title-row'>
        <Col lg={6}>
          <h5>{panelTitle}</h5>
        </Col>
        <Col lg={5}>
          <span id='totalProjectPrice'>Totaal: € {props.totalPrice}</span>
        </Col>
      </Row>

      {panelContent}
      {pageControl}
    </div>
  );
}

export default SidePanel;
